function OriginalDB() {
  return (
    <div>
      <li className="bullet-item">The original source reporting the Gene-Disease Association.</li>
    </div>
  );
}

export default OriginalDB;
